import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ExternalLinkIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 22),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: svgProps.strokeWidth ?? "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /*#__PURE__*/jsx("path", {
      d: "M21 7V1h-6M21 1 7.67 14.33M10.33 5h-8A1.33 1.33 0 0 0 1 6.33v13.34A1.33 1.33 0 0 0 2.33 21h13.34A1.33 1.33 0 0 0 17 19.67v-8"
    })
  });
};

export { ExternalLinkIcon };
//# sourceMappingURL=external-link.js.map
